<div class="page-container">

  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>

  <ng-container *ngIf="!isLoading">
    <app-page-header
      title="Fishing Spots"
      description="Spots are discovered automatically from dwell time analysis when a trip completes. Click a spot to name it, edit the centroid, and view satellite analysis.">
      <button class="action-btn" (click)="recomputeAllSpots()" [disabled]="isRecomputing"
        title="Delete all dwell events and recompute fishing spots for every completed trip. Long-running background job — progress shown in notifications.">
        {{ isRecomputing ? 'Recomputing…' : 'Re-detect All Spots' }}
      </button>
      <button class="action-btn" (click)="toggleAddForm()"
        title="Manually pin a fishing spot by entering GPS coordinates">
        {{ showAddForm ? 'Cancel' : 'Add Spot Manually' }}
      </button>
      <span class="recompute-status" *ngIf="recomputeStatus">{{ recomputeStatus }}</span>
    </app-page-header>

    <!-- Add spot form -->
    <div class="add-spot-form" *ngIf="showAddForm">
      <h3 class="form-title">New Fishing Spot</h3>
      <div class="form-row">
        <label class="form-label">Latitude</label>
        <input class="form-input" [(ngModel)]="newLat" placeholder="e.g. 39.12345" type="number" step="any" />
        <label class="form-label">Longitude</label>
        <input class="form-input" [(ngModel)]="newLng" placeholder="e.g. -76.54321" type="number" step="any" />
      </div>
      <div class="form-row">
        <label class="form-label">Name <span class="optional">(optional)</span></label>
        <input class="form-input form-input--wide" [(ngModel)]="newName" placeholder="e.g. Osprey Pier" />
        <label class="form-label">Body of Water <span class="optional">(optional)</span></label>
        <input class="form-input form-input--wide" [(ngModel)]="newLocation" placeholder="e.g. Back River" />
      </div>
      <button class="action-btn" (click)="saveNewSpot()" [disabled]="isSavingNew || !newLat || !newLng">
        {{ isSavingNew ? 'Saving…' : 'Save Spot' }}
      </button>
    </div>

    <div *ngIf="spots.data.length === 0" class="empty-state">
      No fishing spots discovered yet. Complete a trip or add one manually.
    </div>

    <div class="table-scroll" *ngIf="spots.data.length > 0">
      <table mat-table [dataSource]="spots" class="spots-table">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name / Location</th>
          <td mat-cell *matCellDef="let spot">
            <span class="spot-name">{{ spot.name || ('Spot #' + spot.id) }}</span>
            <span class="spot-location" *ngIf="spot.location"> · {{ spot.location }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="visits">
          <th mat-header-cell *matHeaderCellDef>Visits</th>
          <td mat-cell *matCellDef="let spot">{{ spot.visit_count }}</td>
        </ng-container>

        <ng-container matColumnDef="time">
          <th mat-header-cell *matHeaderCellDef>Total Time</th>
          <td mat-cell *matCellDef="let spot">{{ formatDuration(spot.total_minutes) }}</td>
        </ng-container>

        <ng-container matColumnDef="catches">
          <th mat-header-cell *matHeaderCellDef>Catches</th>
          <td mat-cell *matCellDef="let spot">{{ spot.catch_count }}</td>
        </ng-container>

        <ng-container matColumnDef="last_visited">
          <th mat-header-cell *matHeaderCellDef>Last Visited</th>
          <td mat-cell *matCellDef="let spot" class="dim">{{ spot.last_visited ? (spot.last_visited | date:'mediumDate') : '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="conditions">
          <th mat-header-cell *matHeaderCellDef>Conditions</th>
          <td mat-cell *matCellDef="let spot">
            <ng-container *ngIf="spot.conditions_confidence !== null && spot.conditions_confidence !== undefined">
              <span class="confidence-score">{{ spot.conditions_confidence }}/10</span>
              <span class="confidence-bar">
                <span class="confidence-fill" [style.width.%]="(spot.conditions_confidence ?? 0) * 10"></span>
              </span>
            </ng-container>
            <span *ngIf="spot.conditions_confidence === null || spot.conditions_confidence === undefined" class="dim">—</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let spot; columns: displayedColumns;" class="spot-row clickable-row" [routerLink]="['/spot', spot.id]"></tr>
      </table>
    </div>
  </ng-container>

</div>
